"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ButtonGroup;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

/**
 * A ZSG [anchor button group](http://static.develop.zillow.net/static-zsg/LATEST/styleguide/core/Buttons.html#anchor-button-group).
 **/
function ButtonGroup(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return _react["default"].createElement("ul", {
    className: (0, _classnames["default"])('zsg-button-group', className)
  }, _react.Children.map(children, function (kid, idx) {
    return _react["default"].createElement("li", {
      key: idx
    }, kid);
  }));
}

ButtonGroup.displayName = 'ButtonGroup';
ButtonGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * [`<Button>`](#button) elements.
   **/
  children: _propTypes["default"].node.isRequired,

  /**
   * Additional classnames for the root element.
   **/
  className: _propTypes["default"].string
} : {};


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/ButtonGroup/index.js
// module id = 524
// module chunks = 0